import { ChatButton, InputModuleWrapper, StyledTextareaAutosize } from './chat.styled';
import { FormWrapper } from '../../input-text/input.styled';

interface ComposerProps {
  inputText: string;
  handleInputChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleKeyPress: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  handleApiCall: () => void;
  loading: boolean;
  onSend: (text: string) => void;
}

export function Composer(props: ComposerProps) {
  const { inputText, handleInputChange, handleKeyPress, handleApiCall, loading, onSend } = props;
  const isEmpty = !inputText.trim().replaceAll(' ', '');

  return (
    <InputModuleWrapper className='space-x-4'>
      <FormWrapper className='w-full mb-0'>
        {/* <Input
          value={inputText}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder='Type your question...'
          disabled={loading}
        /> */}
        <StyledTextareaAutosize
          style={{ boxSizing: 'border-box' }}
          value={inputText}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder='Type your question...'
          disabled={loading}
          minRows={1}
          maxRows={3}
        />
      </FormWrapper>
      <ChatButton
        icon='send'
        variant='primary'
        title={loading ? '' : ''}
        onClick={handleApiCall}
        disabled={loading || isEmpty}
        type='button'
      />
    </InputModuleWrapper>
  );
}
